var map = {
	"./1.jpg": "7815",
	"./2.jpg": "b061",
	"./3.jpg": "4640",
	"./4.jpg": "3e1c",
	"./5.jpg": "a9f9",
	"./6.jpg": "bc95",
	"./7.jpg": "239f",
	"./8.jpg": "c4aa",
	"./9.jpg": "a96a",
	"./g1.jpg": "6a5d",
	"./g2.jpg": "085a",
	"./g3.jpg": "3950",
	"./g4.jpg": "317b",
	"./g5.jpg": "1dd2",
	"./g6.jpg": "ce4d",
	"./g7.jpg": "145d",
	"./g8.jpg": "9e4b",
	"./g9.jpg": "15be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa0e";